import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerAccount extends AManagerApi {
    protected _url: string = '/owner/account';
}
